import { RootState } from "../../store";

export const selectBadge = (state: RootState) => state.badge;